'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _translate = require('../../language/translate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Return a helmet component to generate the page title.
 * @extends {Component}
 */

var HelmetComponent = function HelmetComponent(_ref) {
  var title = _ref.title;
  return _react2.default.createElement(
    _reactHelmet.Helmet,
    null,
    _react2.default.createElement('meta', { charSet: 'utf-8' }),
    _react2.default.createElement(
      'title',
      null,
      title
    )
  );
};

HelmetComponent.propTypes = {
  title: _react2.default.PropTypes.string
};

exports.default = HelmetComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/HelmetComponent.jsx
// module id = 205
// module chunks = 0